import { createFileRoute, redirect } from "@tanstack/react-router";

import { AppLayout } from "@/shared/layouts/app-layout/app-layout";

import { ApiError } from "@/shared/api";

import { currentUserQuery } from "@/features/authentication/queries";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.fetchQuery(currentUserQuery);
    } catch (error) {
      if (error instanceof ApiError && error.isUnauthorized) {
        throw redirect({
          to: "/authentication/login",
        });
      }

      throw error;
    }
  },

  component: AppLayout,
});
